import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded';

const selectedOrHoveredStyles = {
  '&& .active': {
    backgroundColor: 'primary.light',
  },
  backgroundColor: 'secondary.light',
};

const cardContentStyles = {
  '& .active': {
    backgroundColor: 'secondary.light',
  },
  '& .inactive': {
    backgroundColor: 'surface.white',
    border: 1,
    borderColor: 'graphic.light',
  },
  display: 'flex',
  flexFlow: 'column nowrap',
  pt: 0,
  rowGap: 1,
};

const SelectorCard = ({ title, children, selected, onClick }) => {
  const cardStyles = [
    selected && selectedOrHoveredStyles,
    {
      '&:hover': selectedOrHoveredStyles,
      borderRadius: 0,
      boxShadow: 'none',
      cursor: 'pointer',
    },
  ];

  return (
    <>
      <Card onClick={onClick} sx={cardStyles}>
        <CardHeader
          action={<ChevronRightRounded sx={{ color: 'primary.main' }} />}
          slotProps={{
            title: { variant: 'subtitle1' },
          }}
          title={title}
        />
        <CardContent sx={cardContentStyles}>{children}</CardContent>
      </Card>
      <Divider />
    </>
  );
};

SelectorCard.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  title: PropTypes.string.isRequired,
};
SelectorCard.defaultProps = {
  selected: false,
};

export default SelectorCard;
